export const enReplenishment = {
  'stok.replenishment.title': 'Replenishment planning',
  'stok.replenishment.subtitle':
    'Explainable demand, available-to-promise, transfer, and purchase recommendations.',
  'stok.replenishment.empty': 'No planning policies yet. Add one above for an inventory item.',
  'stok.replenishment.policyTitle': 'Planning policy',
  'stok.replenishment.policyDesc':
    'Set the demand window, stock buffer, supplier rules, and receiving location.',
  'stok.replenishment.chooseItem': 'Choose an item',
  'stok.replenishment.destination': 'Destination',
  'stok.replenishment.chooseLocation': 'Choose a location',
  'stok.replenishment.supplier': 'Preferred supplier',
  'stok.replenishment.noSupplier': 'No preferred supplier',
  'stok.replenishment.horizon': 'Planning horizon (days)',
  'stok.replenishment.lookback': 'Demand lookback (days)',
  'stok.replenishment.lead': 'Lead time (days)',
  'stok.replenishment.safety': 'Safety stock (base units)',
  'stok.replenishment.moq': 'MOQ (base units)',
  'stok.replenishment.multiple': 'Order multiple (base units)',
  'stok.replenishment.save': 'Add policy',
  'stok.replenishment.saved': 'Planning policy saved.',
  'stok.replenishment.actionNeeded': 'Action needed',
  'stok.replenishment.covered': 'Covered',
  'stok.replenishment.forecast': 'Forecast demand',
  'stok.replenishment.safetyStock': 'Safety stock',
  'stok.replenishment.onHand': 'On hand',
  'stok.replenishment.blocked': 'Blocked / expired',
  'stok.replenishment.reserved': 'Reserved',
  'stok.replenishment.available': 'Usable available',
  'stok.replenishment.inTransit': 'In transit',
  'stok.replenishment.receipts': 'PO receipts in horizon',
  'stok.replenishment.netRequired': 'Net required',
  'stok.replenishment.formulaNote':
    'Usable available already excludes blocked and reserved stock. Expected receipts include only open POs due within {horizon} days.',
  'stok.replenishment.transferFrom': 'Transfer from {location}',
  'stok.replenishment.purchase': 'Suggested purchase',
  'stok.replenishment.createTransfer': 'Create draft transfer',
  'stok.replenishment.createPr': 'Create draft request',
  'stok.replenishment.noAction': 'No replenishment action is needed.',
  'stok.replenishment.openDraft': 'Open {number}',
  'stok.replenishment.draftCreated': 'Draft {number} created.',
} as const;
